<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex mb-6" v-html="cardContent"></div>

      <ul>
        <li
          v-for="option in options"
          :key="option.id"
          @click="setSelection(option)"
          class="list-select-item"
          :class="{ 'selected-list-select-item': isSelected(option) }"
        >
          <p class="capitalize">{{ option.variationName || option.name || '' }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Side",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Bedienseite",
      cardContent: "",
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("side/", {
      options: (state) => state.options,
      selection: (state) => state.selection,
      defaultSelection: (state) => state.defaultSelection,
    }),
  },

  methods: {
    ...mapMutations("side/", {
      setSelection: "setSelection",
    }),
    getAttributeValue,
    fetchCategoryContent,

    isSelected(option) {
      if (!this.selection) return false;
      return this.selection.id === option.id;
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },
};
</script>

<style></style>
